import { DatabaseEntities } from "../../../common/models/database-entities.model";
import { Accounts } from "../../account/models/accounts.model";

export class Assets extends DatabaseEntities<Assets> {
    uploadedById: number;
    storageId: string;
    name: string;
    uploadedBy: Accounts;
}
